import { useState, useEffect } from 'react'
import { Container, Grid, TextField, Button, Typography, createTheme, Box, Link } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import AppAppBar2 from '../components/AppBar2'
import ProductHeroLayout from '../components/ProductHeroLayout';
import { minHeight, palette } from '@mui/system'
import { useFetchNoUser } from '../hooks/useFetchNoUser'
import CircularProgress from '@mui/material/CircularProgress';
export default function CodeofConduct() {



    const [backgroundImage, setBackgroundImage] = useState('../img/BannerDistance.jpg')




    const navigate = useNavigate()









    return (

        <>

            <AppAppBar2 />
            <ProductHeroLayout
                fullWidth
                sxBackground={{
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundColor: '#7fc7d9', // Average color of the background image.
                    fullWidth: '90vh',
                    transition: 'background 3s linear',
                }}
            >

                <Container maxWidth="md" disableGutters align="center" top="50%" sx={{ backgroundColor: 'white', opacity: '0.7', border: 'Solid', borderWidth: '5px', borderColor: 'primary.main', padding: '30px', borderRadius: 3, marginTop: 3 }}>

                    <Box fullWidth
                        sxBackground={{

                            backgroundColor: 'secondary ', // Average color of the background image.
                            fullWidth: 'calc(85vh)',
                            transition: 'background 3s linear',
                            marginTop: 0,


                        }}>


                        <Box mb={10} />
                        <Box sx={{ display: { xs: 'flex', md: 'flex', l: 'flex', xl: 'flex' }, justifyContent: 'center', margin: '10px' }}>

                            <Button
                                color="secondary"

                                variant="contained"
                                underline="none"
                                href="./CodeOfConduct.pdf"
                                target="_blank"

                            >
                                Download / View
                            </Button>
                        </Box>
                        <Box sx={{ display: { xs: 'none', md: 'flex', l: 'flex', xl: 'flex' }, justifyContent: 'center', margin: '10px' }}>

                            <object data="./CodeOfConduct.pdf" type="application/pdf" height="500px" width="90%" />


                        </Box>
                        <Box sx={{ display: { xs: 'flex', md: 'none', l: 'none', xl: 'none' }, justifyContent: 'center', margin: '10px' }}>

                            <object data="./CodeOfConduct.pdf" type="application/pdf" height="400px" width="90%" />


                        </Box>

                        <Box mb={15} />
                    </Box>
                </Container>
            </ProductHeroLayout>
        </>
    )
}
